import * as React from 'react';
import { HtmlHeadInclude } from '@msdyn365-commerce/core-internal';

const isDev = process.env.NODE_ENV === 'development';

type SharedScriptsProps = {
    googleTagManagerId?: string;
    bazaarVoiceEnv?: string;
    locale: string;
    d365MarketingLibVersion?: string;
    d365MarketingWebsiteId?: string;
};

// tslint:disable-next-line: no-typeof-undefined
const IsClientSide = () => !!(typeof window !== 'undefined' && window.document && window.document.createElement);

const SharedScripts = ({ googleTagManagerId, bazaarVoiceEnv, locale, d365MarketingWebsiteId, d365MarketingLibVersion }: SharedScriptsProps) => {

    const divRef = React.useRef<HTMLDivElement>(null);
    const [initialized, setInitialized] = React.useState(false);

    const [gtagHeaderScript] = React.useMemo(() => {
        if (!googleTagManagerId) {
            return [null];
        }

        return [
            `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${googleTagManagerId}');`,
        ];
    }, [googleTagManagerId]);

    const bvLocale = (locale || 'en-CA').replace('-', '_');
    const bvScript = `https://apps.bazaarvoice.com/deployments/henrys/main_site/${bazaarVoiceEnv || 'staging'}/${bvLocale}/bv.js`;

    const bvHandlerScript = `
window.bvCallback = function (BV) {
    BV.reviews.on('show', function () {
        var elem = document.getElementsByClassName("hei-bv-reviews")[0];
        elem && elem.click();
    });
}
    `;
    const isClientSide = IsClientSide();
    React.useEffect(() => {
        const div = divRef.current;
        if (!initialized && isClientSide && d365MarketingLibVersion && div) {
            setInitialized(true);

            let script = document.createElement('script');
            script.async = true;
            script.src = `https://mktdplp102cdn.azureedge.net/public/latest/js/form-loader.js?v=${d365MarketingLibVersion}`;
            div.appendChild(script);

            if (d365MarketingWebsiteId) {
                let childDiv = document.createElement('div');
                childDiv.id = `d${d365MarketingWebsiteId}`;
                div.appendChild(childDiv);

                childDiv = document.createElement('div');
                childDiv.className = 'd365-mkt-config';
                childDiv.style.display = 'none';
                childDiv.setAttribute('data-website-id', d365MarketingWebsiteId);
                childDiv.setAttribute('data-hostname', 'ed4afb890e8642dc8ee5e6762b36e899.svc.dynamics.com');
                div.appendChild(childDiv);

                script = document.createElement('script');
                script.async = true;
                script.src = `https://mktdplp102cdn.azureedge.net/public/latest/js/ws-tracking.js?v=${d365MarketingLibVersion}`;
                div.appendChild(script);
            }

        }
    }, [isClientSide, initialized, d365MarketingWebsiteId, d365MarketingLibVersion, divRef]);

    if (isDev) {
        React.useEffect(() => {
            const bodyTag = document.getElementsByTagName('body')[0];

            const script = document.createElement('script');
            script.async = true;
            script.src = `/assets/gtm.js`;
            bodyTag.appendChild(script);
        }, []);
    }

    return (
        <div id="hei-shared-script">
            <HtmlHeadInclude>
                {/* tslint:disable-next-line: react-no-dangerous-html */}
                {gtagHeaderScript && <script data-load-point="headStart" dangerouslySetInnerHTML={{ __html: gtagHeaderScript }} />}

                <script data-load-point="headEnd" async src={bvScript} />

                {/* tslint:disable-next-line: react-no-dangerous-html */}
                {gtagHeaderScript && <script data-load-point="headStart" dangerouslySetInnerHTML={{ __html: bvHandlerScript }} />}

            </HtmlHeadInclude>

            <div ref={divRef} />
        </div>

    );
};

export default SharedScripts;
